<template>
  <div class="statistical-result-dialog" v-if="surveyTableData">
    <el-dialog
      title="统计反馈"
      :visible.sync="statisticalResultDialogVisible"
      :before-close="dialogClose"
      @open="dialogOpen"
      width="750px"
    >
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm">
        <el-form-item
          label="调查表名称："
          :label-position="labelPosition"
          style="text-align: left"
        >
          <span>{{ surveyTableData.formName }}</span>
        </el-form-item>
        <el-form-item
          label="反馈内容："
          :label-position="labelPosition"
          style="text-align: left"
          prop="remark"
        >
          <el-input
            :autosize="{ minRows: 2, maxRows: 20}"
            type="textarea"
            v-model="ruleForm.remark"
          ></el-input>
        </el-form-item>
        <el-form-item style="text-align: center">
          <el-button type="primary" @click="submitForm('ruleForm')"
            >确认</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: ["statisticalResultDialogVisible", "surveyTableData"],
  data() {
    return {
      labelPosition: "top",
      ruleForm: {
        remark: "",
      },
      rules: {
        remark: [
          { required: true, message: "请输入反馈内容", trigger: "blur" },
        ],
      },
    };
  },
  inject: ["refresh"],
  methods: {
    // 关闭弹出窗口
    dialogClose() {
      this.$refs["ruleForm"].clearValidate();
      this.$emit("update:statisticalResultDialogVisible", false);
    },
    dialogOpen() {
      this.ruleForm.remark = this.surveyTableData.remark;
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let data = {
            formsId: this.surveyTableData.id,
            remark: this.ruleForm.remark,
          };

          this.post(this.$url.insertStatisticalResult, data).then((res) => {
            // console.log("添加调查表统计反馈==>", res);
            if (res.code !== 200) return this.$message.error(res.msg);

            this.$message.success(res.msg);
            this.refresh();
            this.$emit("update:statisticalResultDialogVisible", false);
          });
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./statisticalResultDialog.scss";
</style>